import { FunctionComponent } from "react";

import ContactCreateForm from "./contactCreateForm";

const CreateContact: FunctionComponent = () => {
  return <ContactCreateForm />;
};

export default CreateContact;
